import { Transition } from "components/shared/column";
import { featureModuleTypesEnum, organizationDocumentsPolicysEnum, sectionTypesEnum } from "helpers/enums";
import { paths } from "helpers/paths";
import React, { useEffect, useState } from "react";
import { CustomScroll } from "react-custom-scroll";
import { Link } from "react-router-dom";
import { index as reportsList } from "sources/books/reports";
import { getCrStartSettings } from "sources/profile/organization";
import connect from "./container";

const defaultItems = [
    { id: "expenses", name: "Общие расходы" },
    { id: "document-tracking", name: "Отслеживание документов" },
];

const tripSheetsItem = [{ id: "trip-sheets", name: "Путевые листы" }];

const crStartItems = [
    { id: "contract", name: "Договора-заявки" },
    { id: "invoice", name: "Счета" },
];

const separateDocumentItems = [
    { id: "acceptance-certificate", name: "Акты" },
    { id: "acceptance-certificate-invoice", name: "Счет-фактуры" },
];

const universalTransferDocumentsItems = [
    { id: "universal-transfer-documents", name: "УПД" },
    { id: "registries", name: "Реестры перевозок" },
];

function FinancesList(props) {
    const [loading, setLoading] = useState(true);
    const [items, setItems] = useState([]);

    useEffect(() => {
        const hasCrStart = props.profile.availableFeatureModules?.includes(featureModuleTypesEnum.CrStart);
        const crStartSettingsReq = hasCrStart ? getCrStartSettings() : Promise.resolve({});

        Promise.all([reportsList(sectionTypesEnum.FinanceAndAccounting), crStartSettingsReq]).then(
            ([res, crStartSettings]) => {
                const showTripSheets = !hasCrStart || !crStartSettings?.hideTripSheets;
                const newItems = [...res, ...defaultItems, ...(showTripSheets ? tripSheetsItem : [])];
                if (hasCrStart) {
                    const usesUniversalTransferDocuments = props.organization.documentsPolicy.includes(
                        organizationDocumentsPolicysEnum.WithUniversalTransferDocuments,
                    );
                    newItems.push(...crStartItems);
                    if (usesUniversalTransferDocuments) {
                        newItems.push(...universalTransferDocumentsItems);
                    } else {
                        newItems.push(...separateDocumentItems);
                    }
                }
                setItems(newItems);
                setLoading(false);
            },
        );
    }, []);

    const close = () => {
        const { history, back } = props;
        back ? back() : history.push(paths.root);
    };

    return (
        <Transition dir="left" wrapper="page-col--overflow-inherit" {...props}>
            <div className="page-book__list book-list list book-list--nofilter book-list--nopagination">
                <div className="book-list__head-wrap">
                    <div className="book-list__head">
                        <div className="book-list__head-close close close--sm" onClick={close} />
                        <div className="book-list__head-title">Финансы и учет</div>
                    </div>
                </div>
                <div className={loading ? "list__body-wrap loading" : "list__body-wrap"}>
                    <div className="list__body content-wrapper">
                        <CustomScroll heightRelativeToParent="100%">
                            <div className="container-fluid">
                                {items.map((item, index) => (
                                    <Link
                                        className="d-block reports__item"
                                        key={item.id}
                                        to={paths.financesShow(item.id)}
                                        name={item.name}
                                    >
                                        {index + 1}. {item.name}
                                    </Link>
                                ))}
                            </div>
                        </CustomScroll>
                    </div>
                </div>
            </div>
        </Transition>
    );
}

export default connect(FinancesList);
